import React from 'react';
import clsx from 'clsx';

import styles from './skeleton.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  animation?: 'pulse' | 'wave' | false;
  children?: React.ReactNode | React.ReactNode[];
  component?: React.ElementType;
  variant?: 'text' | 'rect' | 'circle';
  width?: number | string;
  height?: number | string;
  hideChildren?: boolean;
}

export const Skeleton: React.FC<Props> = (props: Props) => {
  const {
    animation = false,
    children,
    component = 'span',
    variant = 'text',
    width,
    height,
    hideChildren,
    className,
    ...rest
  } = props;

  const effectiveVariant = children ? 'rect' : variant;
  const fitContent = Boolean(children && !hideChildren);

  const cls = clsx(
    styles['skeleton'],
    styles[`skeleton--${effectiveVariant}`],
    fitContent && styles['skeleton--fit-content'],
    animation && styles[`skeleton--${animation}`],
    className
  );

  return React.createElement(
    component,
    {
      className: cls,
      style: { width, height },
      ...rest
    },
    hideChildren && <div style={{ display: 'none' }}>{children}</div>,
    !hideChildren && children
  );
};

export default Skeleton;
